module.exports = __webpack_public_path__ + "static/media/bryanmuli.31da00c8.jpg";